import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { logout } from '../session/logoutThunk';
import { RootState } from '../store';

export type EmulatorState = Readonly<{
  user_id?: string;
  first_name?: string;
  last_name?: string;
  session_id?: string;
}>;

const initialState: EmulatorState = {
  user_id: undefined,
  first_name: undefined,
  last_name: undefined,
  session_id: undefined,
};

export const emulatorSlice = createSlice({
  name: 'emulator',
  initialState,
  reducers: {
    setEmulator: (
      state,
      action: PayloadAction<{
        user_id: string;
        first_name: string;
        last_name: string;
        session_id: string;
      }>,
    ) => {
      state.user_id = action.payload.user_id;
      state.first_name = action.payload.first_name;
      state.last_name = action.payload.last_name;
      state.session_id = action.payload.session_id;
    },
    clearEmulator: (state) => {
      state.user_id = undefined;
      state.first_name = undefined;
      state.last_name = undefined;
      state.session_id = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.user_id = undefined;
      state.first_name = undefined;
      state.last_name = undefined;
      state.session_id = undefined;
    });
  },
});

export const { setEmulator, clearEmulator } = emulatorSlice.actions;

// Selectors
export const selectEmulatorUserId = (state: RootState) => state.emulator?.user_id;

export const selectEmulatorSessionId = (state: RootState) => state.emulator?.session_id;

export const selectIsEmulating = (state: RootState) => !!state.emulator?.user_id;
